module.exports = __webpack_public_path__ + "25d528c71fbf04f59e0214fd6c24f106.png";